export default val => {
  const typeUser = {
    'PROMOTER': 'Promotor',
    'PASSIVE': 'Pasivo',
    'DETRACTOR': 'Detractor',
    'NONE': 'No contestado'
  }
  return typeUser[val]
}
